module.exports = __webpack_public_path__ + "static/img/record3x.0794e2e1.png";